import {emitTrackEvent} from 'common/util/dom';

import {ResourceType} from '../property-filter-menu/models/types';
import type {PropertyItemWithValue} from './index';

enum EventNames {
  InfoClick = `[Lookup table] Learn more about lookup tables`,
}

type InfoClickSource =
  | `query-builder map-lookup-table-modal`
  | `query-builder context-panel`
  | `lexicon map-lookup-table-modal`;
interface TrackInfoClickProps {
  source: InfoClickSource;
}

const sourceQueryBuilder = `query-builder map-lookup-table-modal`;
const cancelable = true;

export function trackUploadComplete({
  el,
  fileSize,
  isNewLookupTable,
  numberOfRowsProcessed,
  numberOfRowsUploaded,
  uploadStatus,
  uploadStatusReason,
  timeToGetUrl,
  timeToUpload,
  timeToProcess,
  totalTime,
  numColumns,
}) {
  const eventPrefix = `[Lexicon] `;
  const eventName = `[Lookup table] Lookup table upload complete`;
  const props = {
    Status: uploadStatus,
    'Status reason': uploadStatusReason,
    '# of rows uploaded': numberOfRowsUploaded,
    '# of rows processed': numberOfRowsProcessed,
    'File size': fileSize,
    'New table': isNewLookupTable,
    'Time to get upload url': timeToGetUrl,
    'Time to upload to GCS': timeToUpload,
    'Time to super import': timeToProcess,
    'Time to upload': totalTime,
    numColumns,
    source: sourceQueryBuilder,
  };
  emitTrackEvent(el, {eventPrefix, eventName, props, cancelable});
}

export function trackSelectTable(el, newTable = false) {
  const eventName = `[Lookup table] Select temporary lookup table`;
  const props = {[`New table`]: newTable};
  emitTrackEvent(el, {eventName, props, cancelable});
}

export function trackInfoClick(el, source: InfoClickSource = sourceQueryBuilder) {
  const eventName = EventNames.InfoClick;
  const props: TrackInfoClickProps = {source};
  emitTrackEvent(el, {eventName, props, cancelable});
}

export function trackCompleteMapping(el, prop: PropertyItemWithValue) {
  const eventPrefix = `[Lexicon] `;
  const eventName = `[Lookup table] Mapping to Lookup table Complete`;
  // existing track call in Lexicon uses 'event property' or 'user property'
  const propType = ((resourceType) => {
    switch (resourceType) {
      case ResourceType.Event:
        return `event property`;
      case ResourceType.User:
        return `user property`;
      default:
        return resourceType;
    }
  })(prop.resourceType);

  const props = {
    'Property type': propType,
    'Override saved mapping': Boolean(prop.dimensionDataGroupId),
    source: sourceQueryBuilder,
  };
  emitTrackEvent(el, {eventPrefix, eventName, props, cancelable});
}
